var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgSy = function SvgSy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 160,
    width: 640,
    height: 160,
    ry: 0,
    rx: 0,
    fill: "#fff",
    fillRule: "evenodd"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 320,
    width: 640,
    height: 160,
    ry: 0,
    rx: 0,
    fillRule: "evenodd"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h640v160H0z",
    fill: "red",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M201.9 281l-28.822-20.867-28.68 21.072 10.667-34.242-28.628-21.145 35.418-.295 10.985-34.138 11.221 34.06 35.418.045-28.481 21.344L201.9 281zm307.64 0l-28.822-20.867-28.68 21.072 10.667-34.242-28.628-21.145 35.418-.295 10.985-34.138 11.221 34.06 35.418.045-28.481 21.344L509.54 281z",
    fill: "#090",
    fillRule: "evenodd"
  })));
};
export default __webpack_public_path__ + "assets/af79e511d22c83769ede4c2d161ef1ef.svg";
export { SvgSy as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/sy.svg